module.exports = __webpack_public_path__ + "img/svgArrow1.1538e093.svg";